module.exports = __webpack_public_path__ + "img/about-icon-2.dd9334ab.svg";